var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from "react";
import _ from "underscore";
import "@frameworks/shared-library/stylesheets/components/TextFirstAlphabetAsIcon/TextFirstAlphabetAsIcon.scss";
var TextFirstAlphabetAsIcon = memo(function (props) {
    var _a, _b, _c;
    var inUpperCase = props.inUpperCase;
    var colorObj = {};
    var alphabet = getTextFirstWord(props.textToExtractWordFrom, inUpperCase);
    if (Array.isArray(props === null || props === void 0 ? void 0 : props.textAndBackgroundColorCollection)) {
        colorObj = randomColorSelector(props.textAndBackgroundColorCollection);
    }
    else if ((props === null || props === void 0 ? void 0 : props.textAndBackgroundColorCollection) instanceof Map) {
        colorObj = getAlphabetColorConfig(alphabet, props === null || props === void 0 ? void 0 : props.textAndBackgroundColorCollection);
    }
    else if ((props === null || props === void 0 ? void 0 : props.textAndBackgroundColorCollection) &&
        !Array.isArray(props === null || props === void 0 ? void 0 : props.textAndBackgroundColorCollection) &&
        !((props === null || props === void 0 ? void 0 : props.textAndBackgroundColorCollection) instanceof Map)) {
        colorObj = __assign({}, props.textAndBackgroundColorCollection);
    }
    return (React.createElement("div", { className: "primary-text-first-word-as-icon-container ".concat((_a = props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement("div", { className: "secondary-container d-flex align-items-center justify-content-center ".concat((_b = colorObj === null || colorObj === void 0 ? void 0 : colorObj.backgroundColor) !== null && _b !== void 0 ? _b : "") },
            React.createElement("span", { className: "".concat((_c = colorObj === null || colorObj === void 0 ? void 0 : colorObj.textColor) !== null && _c !== void 0 ? _c : "", " DMSansMedium_18_500 letter-wrapper") }, alphabet))));
}, function (prev, next) { return _.isEqual(prev, next); });
export default TextFirstAlphabetAsIcon;
export function getTextFirstWord(text, inUpperCase) {
    if (inUpperCase === void 0) { inUpperCase = true; }
    if (!!text) {
        var wordsArr = text.split(" ").join("");
        return inUpperCase ? wordsArr[0].toUpperCase() : wordsArr[0].toLowerCase();
    }
    return "";
}
function randomColorSelector(colorsArr) {
    if (!!colorsArr && colorsArr.length) {
        var objIndex = Math.floor(Math.random() * colorsArr.length);
        return colorsArr[objIndex];
    }
    return {};
}
function getAlphabetColorConfig(alphabet, textBgMap) {
    if (!alphabet || !textBgMap)
        return {};
    return textBgMap.get(alphabet.toLowerCase());
}
